(() => {
  const attachShadow = Element.prototype.attachShadow;
  if (attachShadow.__drawerCartOpen) return;

  const cssHref = document.currentScript && document.currentScript.dataset.walletCss;

  Element.prototype.attachShadow = function (init) {
    const tag = (this.localName || "").toLowerCase();
    const isWalletHost = tag === "shopify-accelerated-checkout-cart" || tag === "shopify-accelerated-checkout";
    const root = attachShadow.call(this, Object.assign({}, init, isWalletHost ? { mode: "open" } : {}));

    if (isWalletHost && cssHref) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = cssHref;
      root.appendChild(link);
    }

    return root;
  };

  Element.prototype.attachShadow.__drawerCartOpen = true;
})();
